// Makes #newsletter-popup link trigger the signup popup
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href="#newsletter-popup"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const popupButton = document.querySelector('.popup__tab-button');
      if (popupButton) {
        popupButton.click();
      }
    });
  });
});
